/* sb-dc-prewarm.js - fetch the variant list while the customer is still
   designing, so add to cart does not have to wait for it.
   2026-09-18 (v1).

   Measured on the live add-to-cart path (2026-09-17, 8x4ft vinyl banner):

     0.21s  GET /products/custom-vinyl-banners.js          206ms
     0.49s  GET /products/custom-vinyl-banners.js?page=2   205ms
     ...    render, encode, upload

   Those two calls are the first thing the cart module does, they run one
   after the other, and they ask for a list that has not changed since the
   page loaded. Roughly half a second of the customer's wait, spent looking
   up something we could already have had.

   So this asks for the same two URLs a few seconds after the editor settles.
   The answers land in the browser's HTTP cache, and the cart module's own
   calls are served from there.

   It does not touch the cart module, the document, or the print file. If the
   fetches fail, or the handle cannot be worked out, nothing happens and add
   to cart behaves exactly as before - it just does not get the head start.

   The handle comes from ?product= first, then sb-dc-handle.js's mapping for
   packaged handles (8x8-...-with-stand and friends), which is the same
   resolution the rest of the design center uses.

   Diagnostics: window.__dcPrewarm() */
(function () {
  'use strict';

  var DELAY = 4000;       // let the editor finish booting first
  var PAGES = 2;          // the cart module reads page 1 and page 2

  var info = { handle: null, pages: [], ms: [], why: '' };
  window.__dcPrewarm = function () { return info; };

  function q(name) {
    try { return new URLSearchParams(location.search).get(name) || ''; }
    catch (e) { return ''; }
  }

  function root() {
    try {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    } catch (e) { return '/'; }
  }

  function handle() {
    var h = q('product');
    if (!h) return null;
    /* A packaged handle (...-with-stand) is not a product the design center
       prices, and sb-dc-handle.js already knows which one it maps to. Use
       that when it is loaded; otherwise use the handle as given. */
    try {
      if (typeof window.__dcHandle === 'function') {
        var m = window.__dcHandle(h);
        if (m && m.dcHandle) return m.dcHandle;
      }
    } catch (e) {}
    return h;
  }

  setTimeout(function () {
    var h = handle();
    if (!h) { info.why = 'no product in url'; return; }
    info.handle = h;

    for (var page = 1; page <= PAGES; page++) {
      (function (p) {
        var url = root() + 'products/' + h + '.js' + (p > 1 ? '?page=' + p : '');
        var t0 = (window.performance && performance.now()) || 0;
        fetch(url, { credentials: 'same-origin' }).then(function (r) {
          info.pages.push(p + ':' + r.status);
          info.ms.push(Math.round(((window.performance && performance.now()) || 0) - t0));
          return r.text();          // drain it so the response is cached
        }).catch(function (e) {
          info.why = 'fetch failed: ' + (e && e.message);
        });
      })(page);
    }
  }, DELAY);
})();
